import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITag } from '../question-tags-selector/question-tags-selector.interface';

@Component({
  selector: 'curr-question-tags-list',
  templateUrl: './question-tags-list.component.html',
  styleUrls: ['./question-tags-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionTagsListComponent {
  @Input() label: string = 'Question Tags';
  @Input() tags: ITag[] = [];

  trackById = (_: number, t: ITag) => t?.id ?? t?.tag;
}
